import React, { Component } from 'react';
import styled from '@emotion/styled';

const Paragraph = styled.p`
  ${props =>
    props.textColor ? `color: ${props.theme[props.textColor]};` : null};
  ${props => (props.marginTop0 ? 'margin-top: 0;' : null)};
  ${props => (props.marginBottom0 ? 'margin-bottom: 0;' : null)};
  text-align: ${props => (props.textAlign ? props.textAlign : 'inherit')};
  font-size: ${props => props.fontSize || 'inherit'};
  font-family: ${props => props.theme.mainFont};
  ${props =>
    props.lineHeight ? 'line-height: ' + props.lineHeight + ';' : null}
`;
class P extends Component {
  render() {
    return (
      <Paragraph
        marginTop0={this.props.marginTop0}
        marginBottom0={this.props.marginBottom0}
        textAlign={this.props.textAlign}
        textColor={this.props.textColor}
        fontSize={this.props.fontSize}
        lineHeight={this.props.lineHeight}
      >
        {this.props.children}
      </Paragraph>
    );
  }
}

export default P;
